import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./filter.html";
import { WireI18n } from '~/modules/stores/i18nStore';
class Filters extends LightningElement {
  constructor(...args) {
    super(...args);
    this.label = void 0;
    this.filterType = void 0;
    this._options = void 0;
  }
  set options(options) {
    // Sort the list alphabetically (copy is made with slice due to .sort() modifying in place)
    this._options = options?.slice().sort((a, b) => {
      return a.name.localeCompare(b.name);
    });
  }
  get options() {
    return this._options;
  }
  i18nCallback(i18n) {
    this.labels = i18n.learn;
  }
  get hasOptions() {
    return this.options?.length > 0;
  }
  handleFilterChange(event) {
    const filterChangeEvent = new CustomEvent('learnfilter', {
      detail: {
        filterType: this.filterType,
        value: event.target.value
      },
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(filterChangeEvent);
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Filters, {
  publicProps: {
    label: {
      config: 0
    },
    filterType: {
      config: 0
    },
    options: {
      config: 3
    }
  },
  track: {
    _options: 1
  },
  wire: {
    i18nCallback: {
      adapter: WireI18n,
      method: 1,
      config: function ($cmp) {
        return {};
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(Filters, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;